import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';
import Moment from 'react-moment';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import { DatePicker } from 'material-ui-pickers';
import { TimePicker } from 'material-ui-pickers';

import indigo from '@material-ui/core/colors/indigo';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import InfoIcon from '@material-ui/icons/Info';

import {
  startAddNote,
  startEditNote,
} from '../../../../store/actions/notes';

const styles = theme => ({
  avatar: {
    marginRight: theme.spacing.unit*2,
  },
  card: {
    marginTop: theme.spacing.unit*3,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing.unit*3,
    marginBottom: theme.spacing.unit*2,
  },
  frequency: {
    minWidth: '180px',
  },
  infoIcon: {
    marginRight: theme.spacing.unit,
  },
  rootContent: {
    backgroundColor: indigo[50],
  },
  title: {
    minWidth: '550px',
  },
  recurring: {
    marginTop: theme.spacing.unit,
  },
  reminderDate: {
    marginTop: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  reminderTime: {
    width: '100px',
  },
  divider: {
    alignSelf: 'center',
    marginTop: theme.spacing.unit*3,
    width: '100%',
  },
  toggle: {
    width: '150px',
  },
});

const noteStatus = (note) => {
  let reminder = "A reminder will occur";

  switch (note.frequency) {
    case undefined:
      return <Moment format="MMM Do, YYYY">{note.reminderDate}</Moment>;
    case "daily":
      return reminder + " daily at " + moment(note.reminderDate).format("hh:mm A");
    case "weekly":
      return reminder + " weekly on " + moment(note.reminderDate).format("dddd") + " at " + moment(note.reminderDate).format("hh:mm A");
    case "monthly":
      return reminder + " monthly on the " + moment(note.reminderDate).format("Do") + " at " + moment(note.reminderDate).format("hh:mm A");
    case "yearly":
      return reminder + " yearly on " + moment(note.reminderDate).format("MMM Do") + " at " + moment(note.reminderDate).format("hh:mm A");
    default:
      return reminder;
  }
}

class NoteDialog extends Component {
  constructor(props) {
    super(props);
    const { note } = props;

    this.state = {
      note: {...note},
    }

  }

  handleChange (propertyName, value) {
    this.setState(function(prevState, props){
       return {
         note: {
           ...prevState.note,
           [propertyName]: value,
         }
       }
    });
  }

  render() {
    const {
      classes,
      project,
      show,
      type,
      handleClose,
      startAddNote,
      startEditNote,
    } = this.props;
    const { note } = this.state;

    return (
      <div>
        <Dialog
          maxWidth="md"
          open={show}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>
            <div className={classes.header}>
              <Avatar aria-label="Note" className={classes.avatar}>
                N
              </Avatar>
              <div>
                <Typography variant="subheading">
                  {type === "edit" ? "Edit Note" : "Add Note"}
                </Typography>
              </div>
            </div>
          </DialogTitle>
          <DialogContent classes={{root: classes.rootContent}}>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <TextField
                  className={classes.title}
                  id="title"
                  label="Title"
                  placeholder="Enter title"
                  margin="normal"
                  value={note.title}
                  onChange={ event => this.handleChange("title", event.target.value)}
                />
                <TextField
                  className={classes.description}
                  id="description"
                  label="Description"
                  multiline
                  rows="3"
                  placeholder="Describe the task"
                  margin="normal"
                  value={note.description}
                  onChange={ event => this.handleChange("description", event.target.value)}
                />
                <div className={classes.reminder}>
                  <FormControlLabel
                    className={classes.toggle}
                    control={
                      <Switch
                        color="primary"
                        checked={note.isReminder}
                        onChange={(event) => this.handleChange("isReminder", event.target.checked)}
                      />
                    }
                    label="Add Reminder"
                  />
                  <DatePicker
                      className={classes.reminderDate}
                      disabled={!note.isReminder}
                      label="Date"
                      format="MMMM Do YYYY"
                      value={note.reminderDate}
                      leftArrowIcon={<ArrowBackIcon />}
                      rightArrowIcon={<ArrowForwardIcon />}
                      onChange={ date => this.handleChange("reminderDate", date.toDate().getTime())}
                    />
                  <TimePicker
                    className={classes.reminderTime}
                    disabled={!note.isReminder}
                    keyboard
                    label="Time"
                    mask={[/\d/, /\d/, ':', /\d/, /\d/, ' ', /a|p/i, 'M']}
                    placeholder="08:00 AM"
                    value={note.reminderDate}
                    onChange={(date) => this.handleChange("reminderDate", date.toDate().getTime())}
                  />
                </div>

                <div className={classes.recurring}>
                  <FormControlLabel
                    className={classes.toggle}
                    control={
                      <Switch
                        color="primary"
                        checked={note.isRecurring}
                        onChange={(event) => this.handleChange("isRecurring", event.target.checked)}
                      />
                    }
                    label="Recurring"
                  />
                  <FormControl className={classes.frequency}>
                    <InputLabel>Type</InputLabel>
                    <Select
                      disabled={!note.isRecurring}
                      value={note.frequency === undefined ? "" : note.frequency}
                      onChange={(event) => this.handleChange("frequency", event.target.value)}
                    >
                      <MenuItem value="daily">Daily</MenuItem>
                      <MenuItem value="weekly">Weekly</MenuItem>
                      <MenuItem value="monthly">Monthly</MenuItem>
                      <MenuItem value="yearly">Yearly</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {note.isReminder &&
                  <div className={classes.column}>
                    <Divider className={classes.divider} />
                    <div className={classes.footer}>
                      <InfoIcon className={classes.infoIcon}/>
                      <Typography>{noteStatus(note)}</Typography>
                    </div>
                  </div>
                }
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (type === "add") {
                  startAddNote(note)
                    .then(() => handleClose());

                } else {
                  const { id, ...updates } = note;
                  startEditNote(id, updates)
                    .then(() => handleClose());
                }
              }}
              color="primary">
              {type === "add" ? "Add" : "Done"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startAddNote: (note) => dispatch(startAddNote(note)),
  startEditNote: (noteId, updates) => dispatch(startEditNote(noteId, updates))
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(NoteDialog)



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Dialog/NoteDialog.jsx